import AgencyCardValue from 'general/components/quybka/Cards/AgencyCardValue';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

GroupReconciliationView.propTypes = {
  reconciliationDetail: PropTypes.object,
};

function GroupReconciliationView(props) {
  // MARK: ---- PROPERTIES ----
  const { reconciliationDetail } = props;
  const cardInfoList = useMemo(() => {
    if (!reconciliationDetail) {
      return [];
    }
    return [
      {
        name: 'Tổng số nhà đầu tư nhóm',
        value: Utils.formatNumber(reconciliationDetail?.metadata?.investors),
        unit: 'NĐT',
        color: 'rgba(230, 25, 110, 1)',
        icon: 'fa-solid fa-users',
      },
      {
        name: 'Tỷ lệ chia sẻ doanh thu của nhóm',
        value: `${reconciliationDetail?.metadata?.groupShareRatio * 100}`,
        unit: '%',
        color: 'rgba(0, 122, 255, 1)',
        icon: 'fa-solid fa-badge-percent',
      },
      {
        name: 'Tổng tài sản của nhóm',
        value: Utils.formatNumber(reconciliationDetail?.metadata?.totalAssets),
        unit: 'VNĐ',
        color: 'rgba(254, 99, 88, 1)',
        icon: 'fa-solid fa-sack-dollar',
      },
      {
        name: 'Tổng chi phí năng lượng',
        value: Utils.formatNumber(reconciliationDetail?.metadata?.energyCost),
        unit: 'VNĐ',
        color: 'rgba(175, 82, 222, 1)',
        icon: 'fa-solid fa-bolt',
      },
      {
        name: 'Doanh thu của nhóm trong tháng',
        value: Utils.formatNumber(reconciliationDetail?.metadata?.groupRevenue),
        unit: 'VNĐ',
        color: 'rgba(255, 170, 36, 1)',
        icon: 'fa-solid fa-hand-holding-usd',
      },
    ];
  }, [reconciliationDetail]);

  return (
    <div>
      <div className="">
        {/* thong tin doi soat */}
        <div className="mt-4">
          <span
            className="px-5"
            style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}
          >
            Thông tin của bạn
          </span>
          <div
            className="row m-0 mt-2 px-3"
            style={{
              borderBottom: `1px dashed ${AppColors.gray[300]}`,
            }}
          >
            <div className="col-lg-4 mb-4 px-2">
              <AgencyCardValue
                name="Tiền hoa hồng phát sinh trong tháng"
                value={Utils.formatNumber(reconciliationDetail?.amount)}
                unit="VNĐ"
                color="rgba(2, 68, 152, 1)"
                backgroundColor="rgba(2, 68, 152, 1)"
                nameColor="#fff"
                valueColor={AppColors.primaryLight}
                unitColor="#fff"
                dividerColor={AppColors.info}
                icon="fa-solid fa-hand-holding-usd"
              />
            </div>
            <div className="col-lg-4 mb-4 px-2">
              <AgencyCardValue
                name="Tỷ lệ chia sẻ doanh thu"
                value={Utils.formatNumber(
                  ((reconciliationDetail?.metadata?.yourShare ?? 0) * 100).toFixed(0)
                )}
                unit="%"
                color="rgba(0, 122, 255, 1)"
                icon="fa-solid fa-badge-percent"
              />
            </div>
            <div className="col-lg-4 mb-4 px-2">
              <AgencyCardValue
                name="Số tiền đầu tư"
                value={Utils.formatNumber(reconciliationDetail?.investment?.amount ?? 0)}
                unit="VNĐ"
                color="rgba(254, 99, 88, 1)"
                icon="fa-solid fa-sack-dollar"
              />
            </div>
          </div>
        </div>

        {/* thong tin nhom dau tu */}
        <div className="mt-4">
          <span
            className="px-5"
            style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}
          >
            Thông tin nhóm đầu tư HTKD
          </span>
          <div className="row mt-2 m-0 px-3">
            {cardInfoList.map((cardInfo, index) => (
              <div className="col-lg-4 mb-4 px-2" key={index}>
                <AgencyCardValue
                  name={cardInfo.name}
                  value={cardInfo.value}
                  unit={cardInfo.unit}
                  color={cardInfo.color}
                  icon={cardInfo.icon}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroupReconciliationView;
